import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { RoundedIcon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ReportEmptyState: React.FC = () => {
  return (
    <Grid container direction="column" alignItems="center" className={cssExports.reportEmptyState}>
      <RoundedIcon icon={IconDefinitionConstants.WSearch} displayType={StyleEnums.DisplayType.None} />
      <Grid container justifyContent="center" className={cssExports.title}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.NoSearchResultsTitle)}
      </Grid>
      <Grid container justifyContent="center" className={cssExports.description}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.NoSearchResultsDescription)}
      </Grid>
    </Grid>
  );
};

export default ReportEmptyState;
